import React from 'react'

const FormButton = () => {
    return (
        <button className="text-base text-center  tracking-[0.3em] bg-brand-primary-color border-white shadow-buttonShadow 
        px-7 py-3 uppercase text-white ">
          Send
        </button>
      );
}


export default FormButton